// Bot money cap per round, the same rule as backend/lib/ngan_sach_bot.js tienVan: the hottest game
// (largest doHot) gets tienVanGameHotNhat, every other game tienVanGameHotNhat x (hotness / largest) ^ doCong,
// and a game's own cap (> 0) wins. The bots page uses it to preview the caps of an unsaved draft.
export type Budget = { bat: boolean; tienVanGameHotNhat: number; doCong: number; tyLeMucTieu: number };

export function maxHot(doHot: Record<string, number>): number {
  let m = 0;
  for (const v of Object.values(doHot)) if (Number.isFinite(v) && v > m) m = v;
  return m > 0 ? m : 1;
}

/** Cap of one game per round, or null when bot money is not capped. */
export function capOf(b: Budget, hot: number, own: number, doHot: Record<string, number>): number | null {
  if (!b.bat) return null;
  if (own > 0) return Math.floor(own);
  if (!(b.tienVanGameHotNhat > 0)) return null;
  return Math.round(b.tienVanGameHotNhat * Math.pow(Math.min(1, Math.max(0, hot) / maxHot(doHot)), b.doCong));
}
